import { Grid, Box } from '@mui/material'
import CommercialCard from './CommercialCard'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import { COMMERCIAL_CARDS, COMMERCIAL_CARD_STYLES } from '../../constants/ClientDashboardConst'
import { formatMoney } from '../../../../helpers/utils'

export default function CommercialSummary({ cardInfo }) {
  const commercialValues = {
    orders: cardInfo.total_orders,
    invoiced: cardInfo.total_invoices,
    delivered: cardInfo.total_deliveries,
    collected: cardInfo.total_charges,
    returned: cardInfo.total_refunds
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {COMMERCIAL_CARDS.map((card) => (
          <Grid key={card.key} item xs={12} sm={6} md={2.4}>
            <CommercialCard
              title={card.title}
              value={
                commercialValues[card.key] != null ? formatMoney(commercialValues[card.key]) : '—'
              }
              icon={
                <GoogleIcon
                  name={card.icon}
                  filled
                  size={COMMERCIAL_CARD_STYLES.iconSize}
                  color={COMMERCIAL_CARD_STYLES.iconColor}
                />
              }
              iconBg={COMMERCIAL_CARD_STYLES.iconBg}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
